import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';

import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2';
import { HandleError } from '../../shared/HandleError';
declare var $: any;

@Component({
  selector: 'app-dependents',
  templateUrl: './dependents.component.html',
  styleUrls: ['./dependents.component.css']
})

export class DependentsComponent implements OnInit {
  SD_Gender_errormessage: string;
  SD_Qualifictaion_errormessage: string;
  cancel: any;
  Relations: any;
  Qualifications: any;
  formInvalid: boolean = false;
  SainikDetails: any;
  AwardsMasters: any;
  data: any;
  s: any = {};
  fd: any = {};
  title = "Details of Dependents";
  mode: string = "save";
  isSainikExist: boolean = false;
  relati: any;
  id: void;
  showModal: boolean = false;
  display = 'none';
  edit: number;
  temp1: any;
  UserName: string;
  RoleName: string;
  finalizeddata: any;
  Formdiable: boolean = false;
  dependentId: any;


  constructor(private service: RegistrationService,private handleError:HandleError) {
  }


  ngOnInit() {
    this.GetAllQualifications();
    this.GetAllRelations();
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.SR_ServiceNo=this.UserName;
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)
    this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo)
    this.GetfinalizeforDependents(this.s.SR_ServiceNo);
  }
  }
  keyPress(event: any) {    
    const pattern =/[A-Za-z]/;
    let inputChar = String.fromCharCode(event.charCode);
    var uname = new String(event.target.value)
    if (!pattern.test(inputChar) && uname.trim().length==0)
    {
      event.preventDefault();
    }
 }
  GetfinalizeforDependents(SR_ServiceNo)
  {
    debugger;
    this.data = this.service.getfinalizeforDependents(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.finalizeddata=response;
        if(this.finalizeddata=='F')
       {
        this.Formdiable=true;
       }
      },
      (error) => {
        console.log(error);
      });
  }
  GetSainikDetailsFromRegistration(SR_ServiceNo: any) {
    debugger;
    this.fd = {};
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForDependents(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.fd.SD_IsDisabled = 'N';
        debugger;
        this.SainikDetails = response;
        this.isSainikExist = true;
        this.s.SR_Id = response.sainikRegistrationBasicDetails.SR_Id;
        this.s = response.sainikRegistrationBasicDetails;
        if (response.SainikDependents.length != 0) {
          this.FamilyDetails = response.SainikDependents;

          // this.fd.qualificationname=this.FamilyDetails.
          this.mode = "update";
        }
        //  this.s.SR_ServiceType=response.sainikRegistrationBasicDetails.ServiceTypes.SR_ServiceType;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
          //swal('Warning!', 'Sainik does not exist.', 'warning');
          swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }


  GetAllQualifications() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllQualification();
    this.data.subscribe(
      (response) => {
        this.Qualifications = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllRelations() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllRelations();
    this.data.subscribe(
      (response) => {
        this.Relations = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  FamilyDetails = [];
  SD_Name_errormessage = "";
  SD_DOB_errormessage = "";
  SD_Relation_errormessage = "";
  SR_Photo_errormessage = "";

  AddFamily(fd) {
    debugger;
    if (this.checkAllFamilyValidation(fd)) {
      let temp = {
        j:fd.j,
        SD_Id: fd.SD_Id,
        SD_Name: fd.SD_Name,
        SD_Gender: fd.SD_Gender,
        SD_DOB: fd.SD_DOB,
        // Relations: fd.SD_Relation,
        // SD_Relation: fd.SD_Relation.Relation_Id,
        relationName: this.GetAllRelationName(fd.relationid),
        //  relationName: fd.SD_Relation.Relation_Name,
        SD_Qualification: this.GetAllQualificationName(fd.qualificationid),
        //SD_Relation_Id_FK:this.fd.relationid, 
        SD_Relation_Id_FK: fd.relationid,
        //SD_Relation_Id_FK:this.GetRelationId(fd.relationName), 
        //SD_Q_Id_FK:this.fd.qualificationid,
        SD_Q_Id_FK: fd.qualificationid,
        //qualificationName: fd.SD_Qualifictaion.Q_Name,
        //QualificationId:this.fd.qualificationid,
        SD_IdCardNo: fd.SD_IdCardNo,
        SD_AdharCard: fd.SD_AdharCard,
        SD_IsDisabled: fd.SD_IsDisabled,
        SD_Email: fd.SD_Email,
        SD_Mobile: fd.SD_Mobile,
        SD_OtherInfo: fd.SD_OtherInfo,
      }

        for (let i = 0; i < this.FamilyDetails.length; i++) {
          // if(this.FamilyDetails.length==0 || this.FamilyDetails.length==undefined)
          // {
          //   this.FamilyDetails.push(fd);
          //   break;
          // }
        //for(let j=0; i < this.fd.length; j++){
                             // if (this.FamilyDetails[i].SD_Id == this.fd.SD_Id) {                            
             let len=this.FamilyDetails.length-1;
               if(i==fd.j && fd.j!=undefined)
               {
                // this.FamilyDetails.push(fd);
                //this.FamilyDetails.push(fd);
                 this.FamilyDetails[i].SD_Name=fd.SD_Name;
                 this.FamilyDetails[i].SD_Gender=fd.SD_Gender;
                 this.FamilyDetails[i].SD_DOB=fd.SD_DOB;
                 this.FamilyDetails[i].relationName=this.GetAllRelationName(fd.relationid);
                 this.FamilyDetails[i].SD_Qualification=this.GetAllQualificationName(fd.qualificationid);
                 //this.FamilyDetails[i].SD_Relation_Id_FK=fd.SD_Relation_Id_FK;
                 this.FamilyDetails[i].SD_Relation_Id_FK=fd.relationid;
                // this.FamilyDetails[i].SD_Q_Id_FK=fd.SD_Q_Id_FK;
                this.FamilyDetails[i].SD_Q_Id_FK=fd.qualificationid;
                 this.FamilyDetails[i].SD_IdCardNo=fd.SD_IdCardNo;
                 this.FamilyDetails[i].SD_AdharCard=fd.SD_AdharCard;
                 this.FamilyDetails[i].SD_Name=fd.SD_Name;
                 this.FamilyDetails[i].SD_IsDisabled=fd.SD_IsDisabled;
                 this.FamilyDetails[i].SD_Email=fd.SD_Email;
                 this.FamilyDetails[i].SD_Mobile=fd.SD_Mobile;
                 this.FamilyDetails[i].SD_OtherInfo=fd.SD_OtherInfo;
               } 
               else if(fd.j==undefined && len==i){
                fd.SD_Relation_Id_FK= fd.relationid;
                fd.SD_Q_Id_FK=fd.qualificationid;
                fd.relationName= this.GetAllRelationName(fd.relationid);
                fd.SD_Qualification=this.GetAllQualificationName(fd.qualificationid);
              this.FamilyDetails.push(fd);
              break;
              }
    
              //  else if(this.FamilyDetails[i]!=this.fd.i){
              //    this.FamilyDetails.push(fd);
              //  }
              //  else if(this.FamilyDetails[i+1]==i) {
              //   this.FamilyDetails[i+1].push(fd);
              //  }   
                              //}   
             
          //this.fd[j]= this.FamilyDetails[i].SD_Id;
           //this.temp1=this.fd[i];
            //this.Removefamily(i);
            //this.FamilyDetails.push(this.FamilyDetails[i]);
            //this.fd = {};
           //this.FamilyDetails.push(this.FamilyDetails.length[i-1].SD_Id);
          // this.FamilyDetails.push(this.FamilyDetails[i-1].SD_Id);
          // this.FamilyDetails.push(this.fd[i])
                                  //}
        // else if(this.fd.SD_Id==0||this.fd.SD_Id==undefined){
        //   this.FamilyDetails.push(temp);
        //   this.fd = {};
      //            }
      //  else if(this.fd.SD_Id==0||this.fd.SD_Id==undefined && this.FamilyDetails[i].SD_Name == this.fd.SD_Name && this.FamilyDetails[i].SD_Gender == this.fd.SD_Gender)
      //  {
      //   this.Removefamily(i);
        //this.FamilyDetails.push(fd);
       //}
       }
       
      //  if(this.fd.SD_Id==0||this.fd.SD_Id==undefined)
      //  {      
      //   this.FamilyDetails.push(fd);
      //  }
       
    
      // else if(this.fd.SD_Id==0||this.fd.SD_Id==undefined && this.FamilyDetails[i].SD_Name == this.fd.SD_Name && this.FamilyDetails[i].SD_Gender == this.fd.SD_Gender)
      //  {
      //    this.Removefamily(i);
      //   this.FamilyDetails.push(fd);
      //  }
      // for (let i = 0; i <this.FamilyDetails.length; i++) {
      //   if (this.FamilyDetails[i].SD_Relation_Id_FK !=null) {
      //     this.FamilyDetails[i].relationName=this.GetAllRelationName(this.FamilyDetails[i].SD_Relation_Id_FK)
      //   }
      // }
      if(this.FamilyDetails.length==0|| this.FamilyDetails.length==undefined){
        fd.SD_Relation_Id_FK= fd.relationid;
        fd.SD_Q_Id_FK=fd.qualificationid;
        fd.relationName= this.GetAllRelationName(fd.relationid);
        fd.SD_Qualification=this.GetAllQualificationName(fd.qualificationid);
        this.FamilyDetails.push(fd);
         }
      this.closeModalDialog();
      this.fd = {};
      this.SD_Relation_errormessage = "";
      console.log(temp);
    }
    else
    {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }

  AddPopUp() {
    // this.popup=true;


    // this.detailspopup.show();
    // this.detailspopup.modal('show');
    // this.EditDependents(i);
  }

  openModalDialog(i) {
    $("#detailspopup").modal('show');
    this.EditDependents(i);
  }

  closeModalDialog() {
    $("#detailspopup").modal('hide');
  }

  EditDependents(i) {
    debugger;
    this.edit=1;
    this.fd = {};
    this.fd = this.FamilyDetails[i];
    this.fd.j=i;
    this.fd.relationid = this.GetRelationId(this.fd.relationName);
    this.fd.qualificationid = this.GetQualifactionId(this.fd.SD_Qualification)
    this.fd['SD_DOB'] = ((this.FamilyDetails[i].SD_DOB).split('T'))[0];
    //this.fd['SD_Qualifictaion']=this.FamilyDetails[i].Qualifications.Q_Id;
    //   this.Removefamily(i);  
    this.closeModalDialog();
  }

  AddButtonClick()
  {
    this.edit=0;
  }

  // Removefamily(i) {
  //   debugger;
  //   this.FamilyDetails.splice(i, 1);
  // }
//editing
  Removefamily(i)
  {
    debugger;
   // for (let j = 0; j < this.FamilyDetails.length; j++) {
     // if (j== i) {
        var dependentId = this.FamilyDetails[i].SD_Id;
        if(dependentId==undefined || dependentId==0)
        {
          this.FamilyDetails.splice(i, 1);
        }
        // return dependentId;
     //}
   // }
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.service.deleteDependent(dependentId).subscribe(
          (data:any) => {
            swal('','Dependent Deleted!','success');
            this.FamilyDetails.splice(i, 1);
            document.getElementById('loader-spinner').style.display="none";
            //this.GetAllDistricts(this.itemsPerPage, 1);
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.handleError.ErrorHandler(error);
          });
      }
    })     
  } 


//   Removefamily(i){
//     document.getElementById('loader-spinner').style.display = "block";
//     // sd.value.SainikDependents = this.FamilyDetails;
//     this.data = this.service.updateDependents(sainikId, this.FamilyDetails);
//     this.data.subscribe(
//       (response) => {
//         console.log(sd);
//         if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
//           this.GetSainikDetailsFromRegistration(this.UserName);
//         }
//         else{
//         sd.reset();
//         sd.resetForm();
//         }
//         this.formInvalid = false;
//         swal('Success!', 'Sainik Dependents details has been updated successfully.', 'success');
//         //this.FamilyDetails = [];
//         document.getElementById('loader-spinner').style.display = "none";
//         // window.location.href='http://sainik.esdinfra.com/index.html#/';
//       }, (error) => {
//         console.log(error);
//         document.getElementById('loader-spinner').style.display = "none";
//         this.handleError.ErrorHandler(error);
//       });
//   }
//   else {
//     swal('Warning!', 'Please enter alteast one dependent details.', 'warning');
//     this.formInvalid = true;
//   }
// }




  GetAllRelationName(relationId) {
    debugger;

    for (let i = 0; i < this.Relations.length; i++) {
      if (this.Relations[i].Relation_Id == relationId) {
        let relationName = this.Relations[i].Relation_Name;
        return relationName;
      }
    }
  }

  GetRelationId(relationName) {
    debugger;
    for (let i = 0; i < this.Relations.length; i++) {
      if (this.Relations[i].Relation_Name == relationName) {
        let relationid = this.Relations[i].Relation_Id;
        return relationid;
      }
    }
  }


  GetQualifactionId(qualifationname) {
    debugger;
    for (let i = 0; i < this.Qualifications.length; i++) {
      if (this.Qualifications[i].Q_Name == qualifationname) {
        let qualificationid = this.Qualifications[i].Q_Id;
        return qualificationid;
      }
    }
  }

  GetAllQualificationName(qualificationId) {
    debugger;
    for (let i = 0; i < this.Qualifications.length; i++) {
      if (this.Qualifications[i].Q_Id == qualificationId) {
        let qualificationName = this.Qualifications[i].Q_Name;
        return qualificationName;
      }
    }
  }

  ClearForm(){
    this.s.SR_ServiceType = "";
    this.s.SR_Category = "";
     this.s.SR_Name = "";
     this.s.SR_SurName = "";
     this.FamilyDetails = [];
   }

   CanAddFamily(i){
    // for (let i = 0; i < this.FamilyDetails.length; i++) {
    //     if (this.FamilyDetails[i].SD_Id == this.fd.SD_Id) {
    //          this.fd.SD_OtherInfo="";
    //          this.fd.SD_IsDisabled="";
    //          this.fd.SD_AdharCard="";
    //          this.fd.SD_Mobile="";
    //          this.fd.SD_IdCardNo="";
    //          this.fd.SD_Email="";
    //     }}
     this.fd={};
   }


  //   CanAddFamily(i){
  //    debugger;
  //    for (let i = 0; i < this.FamilyDetails.length; i++) {
  //      //for(let j=0; i < this.fd.length; j++){
  //      if (this.FamilyDetails[i].SD_Id == this.fd.SD_Id) {
  //      // this.fd[j]=this.FamilyDetails[i];
  //      let temp1 = {
  //       SD_Id: this.fd.SD_Id,
  //       SD_Name:this.fd.SD_Name,
  //       SD_Gender:this.fd.SD_Gender,
  //       SD_DOB:this.fd.SD_DOB,
  //       // Relations: fd.SD_Relation,
  //       // SD_Relation: fd.SD_Relation.Relation_Id,
  //       relationName: this.GetAllRelationName(this.fd.relationid),
  //       //  relationName: fd.SD_Relation.Relation_Name,
  //       SD_Qualification: this.GetAllQualificationName(this.fd.qualificationid),
  //       //SD_Relation_Id_FK:this.fd.relationid, 
  //       SD_Relation_Id_FK:this.fd.relationid,
  //       //SD_Relation_Id_FK:this.GetRelationId(fd.relationName), 
  //       //SD_Q_Id_FK:this.fd.qualificationid,
  //       SD_Q_Id_FK:this.fd.qualificationid,
  //       //qualificationName: fd.SD_Qualifictaion.Q_Name,
  //       //QualificationId:this.fd.qualificationid,
  //       SD_IdCardNo:this.fd.SD_IdCardNo,
  //       SD_AdharCard:this.fd.SD_AdharCard,
  //       SD_IsDisabled:this.fd.SD_IsDisabled,
  //       SD_Email:this.fd.SD_Email,
  //       SD_Mobile:this.fd.SD_Mobile,
  //       SD_OtherInfo:this.fd.SD_OtherInfo,
  //     }
  //     //this.temp1 = {};
  //     //  this.temp1 = this.FamilyDetails[i];
  //     //  this.temp1.relationid = this.GetRelationId(this.fd.relationName);
  //     //  this.temp1.qualificationid = this.GetQualifactionId(this.fd.SD_Qualification)
  //     //  this.temp1['SD_DOB'] = ((this.FamilyDetails[i].SD_DOB).split('T'))[0];
       
  //       // this.temp1[j]=this.FamilyDetails[i]
        
  //          this.fd.SD_OtherInfo="";
  //          this.fd.SD_IsDisabled="";
  //          this.fd.SD_AdharCard="";
  //          this.fd.SD_Mobile="";
  //          this.fd.SD_IdCardNo="";
  //          this.fd.SD_Email="";
  //           // this.fd.SD_Name="";
  //          //this.FamilyDetails[i].SD_IdCardNo="";
  //          //  this.FamilyDetails[i].SD_Email="";
  //        //this.fd=this.temp1;
  //     // }
  //      // this.temp1[i]=this.FamilyDetails[i];
  //     //  this.
  //     //  this.fd[i]="";
  //     //  this.FamilyDetails[i]="";
  //     //  this.fd={};
  //     //  for (let i = 0; i < this.FamilyDetails.length; i++) {
  //     //   //for(let j=0; i < this.fd.length; j++){
  //     //   if (this.FamilyDetails[i].SD_Id == this.fd.SD_Id) {  
  //     //     //this.fd[j]= this.FamilyDetails[i].SD_Id;
  //     //      //this.temp1=this.fd[i];
  //     //       this.Removefamily(i);
  //     //       this.FamilyDetails.push(fd)
  //     //       //this.fd = {};
  //     //      //this.FamilyDetails.push(this.FamilyDetails.length[i-1].SD_Id);
  //     //     // this.FamilyDetails.push(this.FamilyDetails[i-1].SD_Id);
  //     //     // this.FamilyDetails.push(this.fd[i])
  //     // }
  //      // }
  //      //if(this.fd.SD_Id==0||this.fd.SD_Id==undefined)
  //     }
  //      else if(this.FamilyDetails[i].SD_Id == this.fd.SD_ID && this.FamilyDetails[i].SD_Name == this.fd.SD_Name &&  this.FamilyDetails[i].SD_Gender == this.fd.SD_Gender  ||this.fd.SD_Id==0||this.fd.SD_Id==undefined)
  //      {
  //       // this.Removefamily(i);  
  //       // this.FamilyDetails.push(this.fd);
  //       this.closeModalDialog();
  //       // this.fd={};
  //      }  
  //      else{
  //       let temp1 = {
  //         SD_Id:this.fd.SD_Id,
  //         SD_Name:this.fd.SD_Name,
  //         SD_Gender:this.fd.SD_Gender,
  //         SD_DOB:this.fd.SD_DOB,
  //         // Relations: fd.SD_Relation,
  //         // SD_Relation: fd.SD_Relation.Relation_Id,
  //         relationName: this.GetAllRelationName(this.fd.relationid),
  //         //  relationName: fd.SD_Relation.Relation_Name,
  //         SD_Qualification: this.GetAllQualificationName(this.fd.qualificationid),
  //         //SD_Relation_Id_FK:this.fd.relationid, 
  //         SD_Relation_Id_FK:this.fd.relationid,
  //         //SD_Relation_Id_FK:this.GetRelationId(fd.relationName), 
  //         //SD_Q_Id_FK:this.fd.qualificationid,
  //         SD_Q_Id_FK:this.fd.qualificationid,
  //         //qualificationName: fd.SD_Qualifictaion.Q_Name,
  //         //QualificationId:this.fd.qualificationid,
  //         SD_IdCardNo:this.fd.SD_IdCardNo,
  //         SD_AdharCard:this.fd.SD_AdharCard,
  //         SD_IsDisabled:this.fd.SD_IsDisabled,
  //         SD_Email:this.fd.SD_Email,
  //         SD_Mobile:this.fd.SD_Mobile,
  //         SD_OtherInfo:this.fd.SD_OtherInfo,
  //       }
  //      //this.FamilyDetails.push(temp1);

  //      }
  //    }   
  //  }

  saveDependents(sainikId, sd: NgForm) {
    debugger;
    if (this.FamilyDetails.length >= 1) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      // sd.value.SainikDependents = this.FamilyDetails;
      this.data = this.service.saveDependents(sainikId, this.FamilyDetails);
      this.data.subscribe(
        (response) => {
          console.log(sd);
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          sd.reset();
          sd.resetForm();
          this.s.SR_ServiceType = "";
          this.s.SR_Category = "";
          this.s.SR_Name = "";
          this.s.SR_SurName = "";
          }
          this.FamilyDetails = [];
          this.formInvalid = false;
          swal('Success!', 'Sainik Dependents details has been saved successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    }
    else {
      swal('Warning!', 'Please enter alteast one dependent details.', 'warning');
      this.formInvalid = true;
    }
  }

  UpdateDependents(sainikId, sd: NgForm) {
    debugger;    
    if (this.FamilyDetails.length >= 1) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      // sd.value.SainikDependents = this.FamilyDetails;
      this.data = this.service.updateDependents(sainikId, this.FamilyDetails);
      this.data.subscribe(
        (response) => {
          console.log(sd);
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          sd.reset();
          sd.resetForm();
          }
          this.formInvalid = false;
          swal('Success!', 'Sainik Dependents details has been updated successfully.', 'success');
          //this.FamilyDetails = [];
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    }
    else {
      swal('Warning!', 'Please enter alteast one dependent details.', 'warning');
      this.formInvalid = true;
    }
  }


  GetSainikBasicDetails(SR_ServiceNo: any) {
    debugger;
    this.fd = {};
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForDependents(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.fd.SD_IsDisabled = 'N';
        debugger;
        this.SainikDetails = response;
        this.isSainikExist = true;
        this.s.SR_Id = response.sainikRegistrationBasicDetails.SR_Id;
        this.s = response.sainikRegistrationBasicDetails;
        if (response.SainikDependents.length != 0) {
          this.FamilyDetails = response.SainikDependents;

          // this.fd.qualificationname=this.FamilyDetails.
          this.mode = "update";
        }
        //  this.s.SR_ServiceType=response.sainikRegistrationBasicDetails.ServiceTypes.SR_ServiceType;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
        if(this.RoleName=="Super Admin"){
          swal('Warning!', 'Sainik does not exist, Please fill the details', 'warning');
        }
        else{
        swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
         }
          //swal('Warning!', 'Sainik does not exist.', 'warning');
          //swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }



  //*********validation********** */
  CheckRequired(value) {
    if (typeof (value) != undefined && value != '' && value != null)
      return true;
    else
      return false;
  }

  checkAllFamilyValidation(fd: any) {
    let result1 = this.CheckFamilyName(fd.SD_Name);
    let result2 = this.CheckFamilyDOB(fd.SD_DOB);
    let result3 = this.CheckFamilyRelation(fd.relationid);
    let result4 = this.CheckFamilyQualification(fd.qualificationid);
    let result5 = this.CheckFamilyGender(fd.SD_Gender);

    if (result1 && result2 && result3 && result4 && result5)
      return true;
    else
      return false;
  }

  CheckFamilyName(name) {
    if (this.CheckRequired(name)) {
      this.SD_Name_errormessage = "";
      return true;
    }
    else {
      this.SD_Name_errormessage = "Please enter name";
      return false;
    }
  }

  CheckFamilyDOB(dob) {
    if (this.CheckRequired(dob)) {
      this.SD_DOB_errormessage = "";
      return true;
    }
    else {
      this.SD_DOB_errormessage = "Please enter DOB";
      return false;
    }
  }

  CheckFamilyRelation(relation) {
    debugger;
    if (this.CheckRequired(relation)) {
      this.SD_Relation_errormessage = "";
      return true;
    }
    else {
      this.SD_Relation_errormessage = "Please select relation";
      return false;
    }
  }

  CheckFamilyQualification(qualification) {
    if (this.CheckRequired(qualification)) {
      this.SD_Qualifictaion_errormessage = "";
      return true;
    }
    else {
      this.SD_Qualifictaion_errormessage = "Please select qualification";
      return false;
    }
  }

  CheckFamilyGender(gender) {
    if (this.CheckRequired(gender)) {
      this.SD_Gender_errormessage = "";
      return true;
    }
    else {
      this.SD_Gender_errormessage = "Please select one";
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/dependents/dependents.component.ts